<template>
  <el-card body-style="padding:0px 20px" shadow="never">
    <h3 class="common-title mb10">
      岗位要求
      <el-button class="ml10" size="mini" type="primary" @click="editRequirement">{{
        !hasRequirement ? '点击添加岗位要求' : '修改岗位要求'
      }}</el-button>
    </h3>
    <div class="card-content">
      <div class="project-detail-content">
        <div class="project-detail-content-title mb10">
          核心要求：
        </div>
        <pre v-if="project.核心要求汇总">{{ project.核心要求汇总 }}</pre>
        <div v-if="Array.isArray(project.核心要求)&&project.核心要求.length>0">
          <pre v-for="(val,index) in project.核心要求" :key="`${val}${index}`">{{index+1}}、{{ val }}</pre>
        </div>
      </div>
    </div>
    <div v-if="hasRequirement" class="card-content">
      <div class="mb10">
        <p>必须要求：<el-button size="mini" type="danger">必须</el-button></p>
        <div class="tag-box">
          <div
            v-for="(value, label) in bixuRes"
            :key="`JobRequirementBixu${label}`"
            :class="[label !== '核心要求' ? 'tag-item' : 'core-requirement-item']"
          >
            <template v-if="label !== '核心要求'" class="tag-item">
              <span class="mr10" style="">{{ label }}:</span>
              <div>
                <el-tag v-for="v in value" :key="`JobRequirementBixu${label}${v}`" class="mr10" size="mini">{{
                  v
                }}</el-tag>
              </div>
            </template>
            <!-- <template v-else class="core-requirement-item">
              <p v-for="(v, i) in value" :key="`JobRequirementBixu${label}${v}`" class="ft14">{{ i + 1 }}、{{ v }}</p>
            </template> -->
          </div>
        </div>
      </div>
      <div class="mb10">
        <p>优先要求：<el-button size="mini" type="warning">优先</el-button></p>
        <div class="tag-box">
          <div
            v-for="(value, label) in youxianRes"
            :key="`JobRequirementBixu${label}`"
            :class="[label !== '核心要求' ? 'tag-item' : 'core-requirement-item']"
          >
            <template v-if="label !== '核心要求'" class="tag-item">
              <span class="mr10" style="">{{ label }}:</span>
              <div>
                <el-tag v-for="v in value" :key="`JobRequirementBixu${label}${v}`" class="mr10" size="mini">{{
                  v
                }}</el-tag>
              </div>
            </template>
            <!-- <template v-else class="core-requirement-item">
              <p v-for="(v, i) in value" :key="`JobRequirementBixu${label}${v}`" class="ft14">{{ i + 1 }}、{{ v }}</p>
            </template> -->
          </div>
        </div>
      </div>
      <div class="mb10">
        <p>其他要求：<el-button size="mini" type="info">其他</el-button></p>
        <div class="tag-box">
          <div
            v-for="(value, label) in qitaRes"
            :key="`JobRequirementBixu${label}`"
            :class="[label !== '核心要求' ? 'tag-item' : 'core-requirement-item']"
          >
            <template v-if="label !== '核心要求'" class="tag-item">
              <span class="mr10" style="">{{ label }}:</span>
              <div>
                <el-tag v-for="v in value" :key="`JobRequirementBixu${label}${v}`" class="mr10" size="mini">{{
                  v
                }}</el-tag>
              </div>
            </template>
            <!-- <template v-else class="core-requirement-item">
              <p v-for="(v, i) in value" :key="`JobRequirementBixu${label}${v}`" class="ft14">{{ i + 1 }}、{{ v }}</p>
            </template> -->
          </div>
        </div>
      </div>
    </div>

    <!-- component -->
    <AddJobRequirementDialog ref="AddJobRequirementDialog" @confirm="confirmEdit"></AddJobRequirementDialog>
  </el-card>
</template>
<script>
import AddJobRequirementDialog from './AddJobRequirementDialog'
import { defaultProject, defaultCompany } from '../../constant/defaultData'

export default {
  components: { AddJobRequirementDialog },
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
    hasNotValueFields: { type: Array, default: () => [] },
  },
  data() {
    return {
      hasRequirement: false,
      bixuRes: {},
      youxianRes: {},
      qitaRes: {},
      componentType: '岗位要求',
      fields: [
        '性别',
        '婚育',
        '年龄要求',
        '地域',
        '学历要求',
        '倾向学历',
        '职能模块',
        '细分职能',
        '擅长方向',
        '投资风格',
        '目标行业',
        '平台',
        '业绩',
        '工作年限',
        '职级',
        '管理职级',
        '专业职级',
        '标签',
        '核心要求',
        '标签分类',
      ],
    }
  },
  mounted() {
    this.$watch(
      function() {
        // 第一个函数就是处理你要监听的属性，只要将其return出去就行
        return this.project.标签分类
      },
      function(newValue, oldValue) {
        const result = this.project.标签分类 || {}
        const bixu = result.必须 || []
        const youxian = result.优先 || []
        const qita = result.其他 || []
        if ([...bixu, ...youxian, ...qita].length > 0) {
          this.hasRequirement = true
          this.init()
        }
      },
    )
  },
  methods: {
    async editRequirement() {
      this.$refs.AddJobRequirementDialog.open(this.project, this.company)
    },
    async confirmEdit(params) {
      if (this.isEditing) return
      if (Object.keys(params).length === 0) return
      try {
        this.isEditing = true
        await app.service('project').modify({
          id: this.project._id,
          param: params,
        })
        Object.assign(this.project, params)
        this.hasRequirement = true
        this.init()
        this.$emit('confirmEdit', { type: this.componentType, data: params })
        this.$message.success(`修改成功`)
      } catch (e) {
        this.$message.error(`修改失败:${e.msg}`)
      }
      this.isEditing = false
    },
    // dialogConfrim(params) {
    //   Object.assign(this.project, params)
    //   this.hasRequirement = true
    //   this.init()
    // },
    init() {
      const result = this.project.标签分类 || {}
      const bixu = result.必须 || []
      const youxian = result.优先 || []
      const qita = result.其他 || []
      const bixuRes = {}
      const youxianRes = {}
      const qitaRes = {}
      bixu.forEach(v => {
        if (!bixuRes[v.label]) bixuRes[v.label] = []
        bixuRes[v.label].push(v.tag)
      })
      youxian.forEach(v => {
        if (!youxianRes[v.label]) youxianRes[v.label] = []
        youxianRes[v.label].push(v.tag)
      })
      qita.forEach(v => {
        if (!qitaRes[v.label]) qitaRes[v.label] = []
        qitaRes[v.label].push(v.tag)
      })
      this.bixuRes = bixuRes
      this.youxianRes = youxianRes
      this.qitaRes = qitaRes
    },
  },
}
</script>
<style scoped src="../../css/newCreateProject.css"></style>
<style scoped>
.tag-box {
  padding-left: 58px;
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
}
.tag-item {
  min-width: 100px;
  display: flex;
  margin-bottom: 10px;
  margin-right: 15px;
  align-items: center;
}
.core-requirement-item {
  width: 100%;
}
.project-detail-item b,
.project-detail-item-title,
.project-detail-content-title,
.project-detail-content .field-label {
  font-size: 14px;
  color: #999999;
  margin-right: 5px;
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  /* text-indent: 2em; */
  font-size: 14px;
  line-height: 24px;
}
</style>
